import React from 'react';
import { Share2, Copy, MessageCircle } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from './ui/dropdown-menu';

const ShareButton = ({ title, url }) => {
  const shareUrl = url || window.location.href;
  const shareText = `¡Mirá este evento en Mi Tribu! ${title}`;

  const shareWhatsApp = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(`${shareText}\n${shareUrl}`)}`, '_blank', 'noopener');
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('Link copiado al portapapeles');
    } catch {
      // Fallback para navegadores sin permiso de clipboard
      const ta = document.createElement('textarea');
      ta.value = shareUrl;
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        toast.success('Link copiado al portapapeles');
      } catch {
        toast.error('No se pudo copiar el link');
      }
      ta.remove();
    }
  };

  const nativeShare = async () => {
    try {
      await navigator.share({ title: `${title} — Mi Tribu`, text: shareText, url: shareUrl });
    } catch {
      /* user cancelled */
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="w-full border-[#E5E5E5] text-[#525252] hover:bg-[#F5F5F5]"
          data-testid="share-button"
        >
          <Share2 className="w-4 h-4 mr-2" />
          Compartir
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white border-[#E5E5E5]">
        <DropdownMenuItem onClick={shareWhatsApp} className="cursor-pointer" data-testid="share-whatsapp">
          <MessageCircle className="w-4 h-4 mr-2 text-green-600" />
          WhatsApp
        </DropdownMenuItem>
        <DropdownMenuItem onClick={copyLink} className="cursor-pointer" data-testid="share-copy-link">
          <Copy className="w-4 h-4 mr-2 text-[#525252]" />
          Copiar enlace
        </DropdownMenuItem>
        {typeof navigator !== 'undefined' && navigator.share && (
          <DropdownMenuItem onClick={nativeShare} className="cursor-pointer" data-testid="share-native">
            <Share2 className="w-4 h-4 mr-2 text-[#525252]" />
            Más opciones...
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ShareButton;
